// @flow

import UserAPI from 'api/UserAPI';

// User's application
export const userGet = () => {
  return(dispatch: any) => {
    dispatch({ type: 'FETCH_USER_APP' });
    return UserAPI.getUser().then(res => {
      if( res.status === 200 ) {
        dispatch(userGetSuccess(res.data.application));
      } else {
        dispatch(userGetFailure(res));
      }
    }).catch(res => {
      dispatch(userGetFailure(res));
    });
  }
}
export const userGetSuccess = (application: any) => {
  return { type: 'FETCH_USER_APP_SUCCESS', payload: application };
}
export const userGetFailure = (error: any) => {
  return { type: 'FETCH_USER_APP_FAILURE', payload: error };
}
export const userGetReset = () => {
  return { type: 'RESET_USER_APP' };
}

export const userUpdatePasswordSuccess = () => ({ type: 'UPDATE_PASSWORD_SUCCESS' });
export const userUpdatePasswordFailure = () => ({ type: 'UPDATE_PASSWORD_FAILURE' })


// User's applications
export const userApplications = () => {
  return(dispatch: any) => {
    dispatch({ type: 'FETCH_USER_APPS' });
    return UserAPI.getUserApplications().then(res => {
      if( res.status === 200 ) {
        dispatch(userApplicationsSuccess(res.data.applications));
      } else {
        dispatch(userApplicationsFailure(res));
      }
    }).catch(res => {
      dispatch(userApplicationsFailure(res));
    });
  }
}
export const userApplicationsSuccess = (apps: any) => {
  return { type: 'FETCH_USER_APPS_SUCCESS', payload: apps };
}
export const userApplicationsFailure = (error: any) => {
  return { type: 'FETCH_USER_APPS_FAILURE', payload: error };
}
export const userApplicationsReset = () => {
  return { type: 'RESET_USER_APPS' };
}

export const userSetPersonalInfo = (info: any) => {
  return { type: 'USER_SET_PERSONAL_INFO', payload: info };
}

export const userSetScopes = (scopes: any) => {
  return { type: 'USER_SET_SCOPES', payload: scopes };
}

export const userSetNotification = (type: string, value: boolean) => {
  return { type: 'USER_SET_NOTIFICATION', payload: { type: type, value: value }};
}

export const userGetPersonalInfo = () => {
  return(dispatch: any) => {
    return UserAPI.getPersonalInfo().then((res) => {
      dispatch(userSetPersonalInfo(res.data))
    }).catch((err) => {});
  }
}

export const userGetScopes = () => {
  return(dispatch: any) => {
    return UserAPI.getScopes().then((res) => {
      dispatch(userSetScopes(res.data))
    }).catch((err) => { });
  }
}

export const setCurrentScope = (id: number) => {
  return(dispatch: any) => {
    return UserAPI.setScope(id).then((res) => {
    }).catch((err) => {});
  }
}

export const sendDestroyAccountMail = () => {
  return(dispatch: any) => {
    return UserAPI.sendDestroyAccountMail().then((res) => {
      if (res.status === 200) { return res.status };
    }).catch((err) => { });
  }
}

export const setNotification = (type: string, value: boolean) => {
  return(dispatch: any) => {
    let params = { [type]: value };
    return UserAPI.setNotification(params).then((res) => {
      dispatch(userSetNotification(type, value));
    }).catch((err) => { });
  }
}



// WEBPACK FOOTER //
// ./src/actions/user/user.js